import { createElement, isValidElement } from 'react';
import Tooltip from '../Tooltip.jsx';
import {
  entityListMetaDotClass,
  entityListMetaIconClass,
  entityListMetaItemClass,
  entityListMetaTextClass,
  entityListPrimaryMetaClass,
} from './entityListClasses.js';

function renderLucideIcon(icon, props = {}) {
  if (!icon) return null;
  if (isValidElement(icon)) return icon;
  if (typeof icon === 'function' || (typeof icon === 'object' && icon !== null)) {
    return createElement(icon, {
      size: 16,
      'aria-hidden': true,
      className: entityListMetaIconClass,
      ...props,
    });
  }
  return null;
}

function resolveTooltipContent(value) {
  if (value == null || value === false) return null;
  if (typeof value === 'string') {
    const trimmed = value.trim();
    return trimmed === '' ? null : trimmed;
  }
  return value;
}

export function EntityListMetaItems({ items = [], className = '' }) {
  if (!items.length) return null;

  return (
    <div className={[entityListPrimaryMetaClass, className].filter(Boolean).join(' ')}>
      {items.map((item, index) => {
        const label = item.label ?? item.text;
        if (label == null && !item.icon) return null;

        return (
          <span key={item.id ?? item.key ?? `${label}-${index}`} className="inline-flex items-center gap-2">
            {index > 0 ? <span className={entityListMetaDotClass} aria-hidden>•</span> : null}
            <span className={entityListMetaItemClass}>
              {renderLucideIcon(item.icon)}
              {label != null && label !== '' ? (
                <span className={[entityListMetaTextClass, item.className].filter(Boolean).join(' ')}>
                  {label}
                </span>
              ) : null}
            </span>
          </span>
        );
      })}
    </div>
  );
}

export function EntityListSecondaryMetaItems({ items = [], className = '' }) {
  if (!items.length) return null;

  return (
    <div className={className}>
      {items.map((item, index) => {
        const label = item.label ?? item.text;
        const showLabel = label != null && label !== '';
        const tooltipContent = resolveTooltipContent(item.tooltip);
        if (!item.icon && !showLabel) return null;

        const inner = (
          <span className={entityListMetaItemClass}>
            {renderLucideIcon(item.icon)}
            {showLabel ? (
              <span className={[entityListMetaTextClass, item.className].filter(Boolean).join(' ')}>
                {label}
              </span>
            ) : null}
          </span>
        );

        return (
          <span
            key={item.id ?? item.key ?? `${label ?? ''}-${index}`}
            className="inline-flex h-6 items-center gap-4"
          >
            {index > 0 ? <span className={entityListMetaDotClass} aria-hidden>•</span> : null}
            {tooltipContent ? (
              <Tooltip
                content={tooltipContent}
                position="bottom"
                align="center"
                size="compact"
                delay={0}
                closeDelay={150}
                triggerClassName="inline-flex items-center"
              >
                {inner}
              </Tooltip>
            ) : (
              inner
            )}
          </span>
        );
      })}
    </div>
  );
}
